export const claimTypeOptions = [
	{
		value: 1,
		name: 'Nepřednostní',
	},
	{
		value: 2,
		name: 'Přednostní',
	},
];

export const husbandOptions = [
	{
		value: 1,
		name: 'ANO',
	},
	{
		value: 0,
		name: 'NE',
	},
];
